import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { ControlsOf, FormGroup } from '@ngneat/reactive-forms';
import { FormQuestionStandard } from '../../../core/models/form-group-mapping.model';
import { QuestionStructureWorksite } from '../../../core/models/question/question-worksite.model';
import { Question } from '../../../core/models/question/question.model';

@Component({
  selector: 'lib-question-oreg',
  templateUrl: './question-oreg.component.html',
  styleUrls: ['./question-oreg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuestionOregComponent {
  labelPrefix = input<string>();
  repeaterGroupId = input<string>();
  question = input<Question>();
  questionForm = input<FormGroup<ControlsOf<FormQuestionStandard>>>();
  isChangeRequest = input<boolean>();

  oregType = computed(
    () => (this.question().structure as QuestionStructureWorksite).oregType,
  );
}
